module.exports = __webpack_public_path__ + "static/media/1008312.9c8e3d1d.png";